import React from 'react';
import { Icon } from '@iconify/react';

const ExpenseSummaryCard = ({ expenses = [] , trucksExpenses }) => {
  // Compute counts and totals for each expense type
  const officeExpenses = expenses.filter(exp => exp.expense_type === 'office_operations');
  const staffExpenses = expenses.filter(exp => exp.expense_type === 'staff');
  

  const officeCount = officeExpenses.length;
  const staffCount = staffExpenses.length;
  const truckCount = trucksExpenses?.length;

  const officeTotal = officeExpenses.reduce((sum, exp) => sum + (parseFloat(exp.amount) || 0), 0);
  const staffTotal = staffExpenses.reduce((sum, exp) => sum + (parseFloat(exp.amount) || 0), 0);
  const truckTotal = trucksExpenses.reduce((sum, exp) => sum + (parseFloat(exp.amount) || 0), 0);

  const cardData = [
    {
      type: 'Office',
      count: officeCount,
      total: officeTotal,
    },
    {
      type: 'Staff',
      count: staffCount,
      total: staffTotal,
    },
    {
      type: 'Truck',
      count: truckCount,
      total: truckTotal,
    },
  ];

  return (
    <div className="row g-3 mb-4" style={{columnGap: 10,paddingLeft: 10,paddingBottom:10}}>
      {cardData.map((card, index) => (
        <div
          key={index}
          className="col-md-3 card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2"
        >
          <div className="">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-success-main flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                    <Icon icon="mingcute:money-fill" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      {card.type} ({card.count})
                    </span>
                    <h6 className="fw-semibold">${card.total.toFixed(2)}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ExpenseSummaryCard;